import React from 'react';
import PropTypes from 'prop-types';
// import { useTranslation } from 'react-i18next';
import Card from '../../../../components/Card';

const PLUGIN_HELP_PAGE_URL =
    'https://www.loom.com/share/933f0a086afc4d10aa0fbeef17f5a600';

const BLANK = '_blank';
const Tags = ({ tags = [] }) => {
    // const { t } = useTranslation();

    return (
        <>
            <Card className="min-h-18">
                <div className="overflow-auto">
                    <h4 className="f4 mt0 mb3">{`Tags de Contatos`}</h4>
                    <div>
                        {`Para atualizar uma tag de contato é bem fácil.`}
                        <ol>
                            <li>{`Crie uma ação do tipo 'Registro de evento' no builder com a categoria 'tag' e a action 'create'.`}</li>
                            <li>{`Adicione um campo extras chamado 'tagName' com um dos valores apresentados na lista abaixo.`}</li>
                            <li>
                                <b>
                                    {`O evento criado deve possuir o campo extras 'email' contendo o email do contato que receberá a tag.`}
                                </b>
                            </li>
                        </ol>
                        <i>{`Obs.: Caso não exista nenhuma tag abaixo verifique se você já criou alguma tag no Active Campaign`}</i>
                    </div>
                    <a
                        className="f6 flex items-center blue no-underline underline-hover"
                        href="#0"
                        data-testid="exemple-one"
                        onClick={() => {
                            window.open(PLUGIN_HELP_PAGE_URL, BLANK);
                        }}
                    >
                        <bds-icon name="file-txt-1" size="x-small" />
                        {`Clique aqui para ver um exemplo de como adicionar tags em seus contatos do Active Campaign`}
                    </a>
                    <br />
                    <table className="f6 w-100 mw8 center">
                        <tbody className="lh-copy">
                            {tags.map((cf, i) => (
                                <tr key={`cf-${i}`}>
                                    <td className="pv3 bb b--black-20">
                                        {cf.tag}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <br />
                </div>
            </Card>
        </>
    );
};

Tags.propTypes = {
    tags: PropTypes.array
};

export default Tags;
